import { twJoin } from 'tailwind-merge';

import { BaseButton, Props } from './BaseButton';

export const TransparentButton = ({ className, ...rest }: Props) => {
  return (
    <BaseButton
      {...rest}
      className={twJoin(
        'rounded-lg text-slate-200 hover:bg-gray-100  dark:hover:bg-gray-700 focus-visible:outline-blue-600',
        className,
      )}
    />
  );
};
